import styled from 'styled-components';
import { device } from 'styles/breakpoints';
import { theme } from 'styles/theme';

export interface ISectionText {
  sectionNumber: number;
  heading: string;
  description?: string;
  error?: string;
  children?: React.ReactNode;
}

const SectionText = ({
  sectionNumber,
  heading,
  description,
  children,
  ...props
}: ISectionText): JSX.Element => {
  return (
    <Wrapper {...props}>
      <SectionNumber>{sectionNumber}</SectionNumber>
      <Heading>{heading}</Heading>
      <Description>{description}</Description>
      {children}
    </Wrapper>
  );
};

export default SectionText;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  text-align: center;
`;

const SectionNumber = styled.h1`
  font-family: var(--secondary-font);
  font-size: 40px;
  color: ${theme.colors.remondis_accent};
  margin: 0;
`;

const Heading = styled.h2`
  font-size: 1.5rem;
  letter-spacing: -0.02px;
  font-weight: bold;
  margin: 1rem 0;
  line-height: 100%;
`;

const Description = styled.p`
  color: ${theme.colors.secondary_text};
  font-weight: 500;
  font-size: 1rem;
  letter-spacing: -0.02px;
  line-height: 1.7;
  margin: 0;
  white-space: normal;

  @media ${device.sm} {
    white-space: pre-wrap;
  }
`;
